export const cadPlanGroups = [
    'Free',
    'Pro',
    'Other',
    'Enterprise',
    'Pro Trial',
    'Standard',
    'EDU Enterprise',
    'EDU Standard',
    'EDU Educator',
];
export const isPaidPlan = (planGroup) => {
    if (planGroup === 'Enterprise' || planGroup === 'Pro' || planGroup === 'Standard')
        return true;
    return false;
};
/** low indexes can upgrade to higher indexes, but no downgrades allowed */
const planGroupsRanked = [
    'Free',
    'EDU Standard',
    'Pro Trial',
    'Standard',
    'Pro',
    'Enterprise',
    'EDU Educator',
    'EDU Enterprise',
];
export const canUpgradeFromTo = ({ from, to, }) => {
    if (from === 'Other')
        return false;
    if (!planGroupsRanked.includes(from)) {
        console.error('Unrecognized planGroup');
        return false;
    }
    if (planGroupsRanked.indexOf(from) >= planGroupsRanked.indexOf(to)) {
        return false;
    }
    console.log('can upgrade: ', { from, to });
    return true;
};
